import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
Vue.config.productionTip = false
Vue.prototype.$axios = axios

import './assets/reset.css'
Vue.use(ElementUI)
Vue.use(VueClipboard)
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
